import { createSingleTaskWorker } from 'app/modules/wallforming/components/workers/createWorkerSingleton';
import { default as DraggingBoxWorker } from 'app/modules/wallforming/components/workers/draggingBox.worker?worker';

import type { Point3D } from 'api/models';

export interface DraggingBoxWorkerInput {
    type: 'computeDraggingBox';
    articleTypes: Array<{
        id: string;
        matrixWorld: number[];
        geomMin: Point3D;
        geomMax: Point3D;
    }>;
    instances: Array<{
        position: Point3D;
        alignment: Point3D;
        rotation: number;
        articleTypeId: string;
    }>;
    anchor: {
        position: Point3D;
        alignment: Point3D;
        rotation: number;
    };
}

export interface DraggingBoxWorkerResult {
    type: 'draggingBoxResult';
    localMin: Point3D;
    localMax: Point3D;
    localToWorld: number[]; // 4×4 matrix
    anchorWorldPosition: Point3D;
    isEmpty: boolean;
}

const draggingBoxWorker = createSingleTaskWorker<DraggingBoxWorkerInput, DraggingBoxWorkerResult>(
    () => new DraggingBoxWorker(),
    'DraggingBoxWorker'
);

export const acquireDraggingBoxWorker = (): void => draggingBoxWorker.acquire();
export const releaseDraggingBoxWorker = (): void => draggingBoxWorker.release();
export const postDraggingBoxTask = (data: DraggingBoxWorkerInput): Promise<DraggingBoxWorkerResult> =>
    draggingBoxWorker.postTask(data);
